import React from 'react';
import {Route, Routes} from 'react-router-dom';
import AgreementsDashboard from "./AgreementsDashboard";
import ClientAgreements from "./ClientAgreements";
import EmployeeContracts from "./EmployeeContracts";

const AgreementsRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<AgreementsDashboard />} />
      <Route path="/client-agreements" element={<ClientAgreements />} />
      <Route path="/employee-contracts" element={<EmployeeContracts />} />

    </Routes>
  );
}

export default AgreementsRoutes;
